import type { FaireProductEntity } from "../../entity_types/product";

export const p_72s9zq98bw: FaireProductEntity = {
  token: "p_72s9zq98bw",
  type: "product",
  name: "LM-SK-1000 BUBBLE SKIRT - DARK BROWN",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/13fc971c708cf41e24e723ee85c887b4fee6c87092364aa9fdcd560e528302dd.jpeg",
  galleryImageUrls: [],
  priceDollars: 17.5,
  description: "",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:32.199Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
